import { render } from "./WaiterOrder.vue?vue&type=template&id=567112ad&scoped=true"
import script from "./WaiterOrder.vue?vue&type=script&lang=js"
export * from "./WaiterOrder.vue?vue&type=script&lang=js"

import "./WaiterOrder.vue?vue&type=style&index=0&id=567112ad&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567112ad"]])

export default __exports__